<template>
  <div>
    <b-modal :id="`bv-modal-change-status-${page}`" hide-footer>
      <template #modal-title>Change status</template>

        <div class="text-center" v-if="product.images">
            <span v-if="product.images.length > 0">
                <img v-if="product.images[0].url" :src="product.images[0].url" class="product_image" />
                <img v-else :src="product.images[0]" class="product_image" />
            </span>
            <img v-else class="product_image" src="/images/image-not-found.svg" />
        </div>

      <div class="pt-2 text-center"><b>{{product.name}}</b></div>

    <div class="bg-white rounded">
      <div class="row">
        <div class="col">
            <label class="form-label">Status</label>
            <select class="form-control2" v-model="product.status" style="padding: 0.7rem 1.2rem;">
                <option v-for="(apple, index) in statuses" :key="index" :value="apple">{{apple}}</option>
            </select>
        </div>
      </div>
    </div>

      <div class="row pt-3 pb-2">
        <div class="col">
          <button type="button" class="btn btn-secondary submit col" @click="hideModalChangeStatus">Cancel</button>
        </div>
        <div class="col">
          <button v-if="updating" type="button" class="btn btn-success submit col">
          <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
          <button v-else type="button" class="btn btn-success submit col" @click="saveEmail">Change</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
  props: ['product','page'],

  data() {
    return {
      updating: false,
      loading: false,
      statuses: ['Approved', 'Inactive'],
    };
  },

  created() {
    
  },

  methods: {

    hideModalChangeStatus() {
      this.$bvModal.hide(`bv-modal-change-status-${this.page}`);
    },

    successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            });
      },

    saveEmail() {

        this.updating = true;

        axios.post('/products/update-status', {
        product_id: this.product.id,
        status: this.product.status
        })
        .then((response) => {

            if (response.data.success) {
                EventBus.$emit('status-updated');
                this.hideModalChangeStatus();
                this.successAlert(response.data.message);
            } else {
                this.sweetfire(response.data.message);
            }

            this.updating = false;

        });

      },

      sweetfire(text) {

        Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Ok',
        customClass: {
                title: "popup-title",
              },
        })

    },
  },
};
</script>

<style scoped>
.product_image { height:3rem; }
</style>